<template>
  <div class="teams-wrapper">
    <div class="tab-options"></div>
    <div class="teams-widget">
      <multipane class="custom-resizer" layout="vertical">
        <div class="teams-list">
          <div class="teams-header">
            <div class="cvs-path">
              <span
                v-for="(item, index) in cvs_path"
                :key="index"
                :class="{
                  active: item.active,
                }"
                >{{ item.label
                }}<span v-if="cvs_path.length - 1 > index" class="divider"
                  >></span
                ></span
              >
            </div>
            <div class="search-add-btn-widget">
              <div class="search-widget">
                <img src="@/assets/icons/search.svg" alt />
                <input
                  v-model="search_input"
                  type="text"
                  placeholder="Type in to Search…"
                />
              </div>
            </div>
            <div class="team-title-options">
              <h1 class="team-title">All Teams</h1>
              <div class="options">
                <c-button
                  class="btn-add"
                  :loading="cv_download_milt_loading"
                  @click="exportMiltipleCv()"
                  v-if="checked_consultant.length > 0"
                >
                  Export CV({{ checked_consultant.length }})
                </c-button>
              </div>
            </div>
          </div>

          <div class="teams-body" v-if="isPermited">
            <div
              class="departiment-item"
              v-for="(item, i) in department_data"
              :key="i"
            >
              <div
                class="department-header"
                :class="{ active: item.expanded }"
                @click.self="expandDepartment(item, i)"
              >
                <div class="start" @click="expandDepartment(item, i)">
                  <label class="dep-label"
                    >{{ item.name | validate }} |
                    {{ item.teams.length | validate }} Teams</label
                  >
                </div>
                <div class="options">
                  <button>
                    <img
                      v-if="item.expanded"
                      src="@/assets/admin-icon/green-caret-up.svg"
                    />
                    <img v-else src="@/assets/admin-icon/gray-caret-down.svg" />
                  </button>
                </div>
              </div>
              <div
                class="department-body"
                v-show="item.expanded && item.teams.length > 0"
              >
                <div class="teams-widget">
                  <template v-for="(team, index) in item.teams">
                    <div class="team-row" :key="index">
                      <div
                        class="team-header"
                        :class="{ active: team.expanded }"
                        @click.self="expandTeam(item, team)"
                      >
                        <input
                          @change="checkTeam($event, team)"
                          class="checkbox"
                          type="checkbox"
                        />
                        <div
                          @click="expandTeam(item, team)"
                          class="profile-alphabet"
                        >
                          <span>{{ $nameInitials(team.name) | validate }}</span>
                        </div>
                        {{ team.name }}
                      </div>
                      <div
                        class="team-body"
                        v-show="team.expanded && team.consultants.length > 0"
                      >
                        <table class="table-data">
                          <tbody class="table-body">
                            <template
                              v-for="(consultant, index) in team.consultants"
                            >
                              <tr :key="index" class="row-data">
                                <td
                                  @click="
                                    selectConsultant(item, team, consultant)
                                  "
                                >
                                  <div class="profile-content center">
                                    <input
                                      v-model="consultant.checked"
                                      @change="
                                        checkConsultant($event, consultant)
                                      "
                                      class="checkbox"
                                      type="checkbox"
                                    />
                                    <div class="profile-alphabet">
                                      <span>{{
                                        $nameInitials(
                                          consultant.first_name +
                                            " " +
                                            consultant.last_name
                                        ) | validate
                                      }}</span>
                                    </div>
                                    <span class="names">
                                      {{
                                        consultant.first_name +
                                        " " +
                                        consultant.last_name
                                      }}
                                      <p
                                        class="location"
                                        v-if="consultant.profile"
                                      >
                                        {{
                                          consultant.profile.address | validate
                                        }}
                                      </p>
                                    </span>
                                  </div>
                                </td>
                                <td
                                  @click="
                                    selectConsultant(item, team, consultant)
                                  "
                                >
                                  <p>{{ consultant.email | validate }}</p>
                                  <p v-if="consultant.profile">
                                    {{ consultant.profile.phone | validate }}
                                  </p>
                                </td>

                                <td>
                                  <div class="menu">
                                    <dropdownMenu>
                                      <ul>
                                        <li>
                                          <a
                                            @click.prevent="
                                              viewProfile(consultant)
                                            "
                                            href="#"
                                            >View Profile</a
                                          >
                                        </li>
                                        <li>
                                          <a
                                            @click.prevent="
                                              exportCv(consultant)
                                            "
                                            href="#"
                                            >Export CV</a
                                          >
                                        </li>
                                      </ul>
                                    </dropdownMenu>
                                  </div>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div
                v-if="item.expanded && item.teams.length == 0"
                class="department-body"
              >
                <label>No team in this department</label>
              </div>
            </div>
          </div>
          <!-- For team manager -->
          <div class="teams-body" v-else>
            <div class="departiment-item">
              <div class="department-body" v-if="teams_data.length > 0">
                <div class="teams-widget">
                  <template v-for="(team, index) in teams_data">
                    <div class="team-row" :key="index">
                      <div
                        class="team-header"
                        :class="{ active: team.expanded }"
                      >
                        <input
                          @change="checkTeam($event, team)"
                          class="checkbox"
                          type="checkbox"
                        />
                        <div
                          class="profile-alphabet"
                          @click="expandTeam(null, team)"
                        >
                          <span>{{ $nameInitials(team.name) | validate }}</span>
                        </div>
                        {{ team.name }}
                      </div>
                      <div
                        class="team-body"
                        v-show="team.expanded && team.consultants.length > 0"
                      >
                        <table class="table-data">
                          <tbody class="table-body">
                            <template
                              v-for="(consultant, index) in team.consultants"
                            >
                              <tr :key="index" class="row-data">
                                <td
                                  @click="
                                    selectConsultant(null, team, consultant)
                                  "
                                >
                                  <div class="profile-content center">
                                    <input
                                      @change="
                                        checkConsultant($event, consultant)
                                      "
                                      v-model="consultant.checked"
                                      class="checkbox"
                                      type="checkbox"
                                    />
                                    <div class="profile-alphabet">
                                      <span>{{
                                        $nameInitials(
                                          consultant.first_name +
                                            " " +
                                            consultant.last_name
                                        ) | validate
                                      }}</span>
                                    </div>
                                    <span class="names">
                                      {{
                                        consultant.first_name +
                                        " " +
                                        consultant.last_name
                                      }}
                                      <p
                                        class="location"
                                        v-if="consultant.profile"
                                      >
                                        {{
                                          consultant.profile.address | validate
                                        }}
                                      </p>
                                    </span>
                                  </div>
                                </td>
                                <td
                                  @click="
                                    selectConsultant(null, team, consultant)
                                  "
                                >
                                  <p>{{ consultant.email | validate }}</p>
                                  <p v-if="consultant.profile">
                                    {{ consultant.profile.phone | validate }}
                                  </p>
                                </td>

                                <td>
                                  <div class="menu">
                                    <dropdownMenu>
                                      <ul>
                                        <li>
                                          <a
                                            @click.prevent="
                                              viewProfile(consultant)
                                            "
                                            href="#"
                                            >View Profile</a
                                          >
                                        </li>
                                        <li>
                                          <a
                                            @click.prevent="
                                              exportCv(consultant)
                                            "
                                            href="#"
                                            >Export CV</a
                                          >
                                        </li>
                                      </ul>
                                    </dropdownMenu>
                                  </div>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div v-else class="department-body">
                <label>No team Available</label>
              </div>
            </div>
          </div>
          <!-- End -->
        </div>
        <multipane-resizer></multipane-resizer>
        <div
          class="consultant-details"
          :style="{ flexGrow: 1 }"
          v-if="selected_consultant"
        >
          <div class="profile-container">
            <div class="consultant-header">
              <div class="consultant-content">
                <div
                  class="profile-widget"
                  @click.prevent="viewProfile(selected_consultant)"
                >
                  <img
                    class="profile-image"
                    v-if="selected_consultant.profile_picture"
                    src=""
                    alt=""
                  />
                  <div v-else class="profile-alphabet">
                    <span>{{
                      $nameInitials(
                        selected_consultant.first_name +
                          " " +
                          selected_consultant.last_name
                      ) | validate
                    }}</span>
                  </div>
                </div>
                <div class="consultant-info">
                  <h1 class="consultant-name">
                    {{
                      selected_consultant.first_name +
                      " " +
                      selected_consultant.last_name
                    }}
                  </h1>
                  <span v-if="selected_consultant.profile" class="location">{{
                    selected_consultant.profile.address
                  }}</span>
                </div>
              </div>
              <div class="options">
                <button class="btn-add" @click="addNewCv(selected_consultant)">
                  + Upload CV
                </button>
                <button
                  class="btn-add"
                  @click.prevent="exportCv(selected_consultant)"
                >
                  Generate CV
                </button>
              </div>
            </div>
            <div
              class="consultant-body"
              v-if="
                selected_consultant.profile &&
                selected_consultant.profile.description
              "
            >
              <h1>Description</h1>
              <p v-html="selected_consultant.profile.description"></p>
            </div>
          </div>
          <div class="cvs-widget">
            <div class="my-cvs-header">
              <h1>My CVs</h1>
            </div>
            <div class="my-cvs-body">
              <table class="table-data" v-if="consultant_cvs.length > 0">
                <thead class="table-header">
                  <tr>
                    <th>CVs</th>
                    <th>Date created</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <template v-for="(item, index) in consultant_cvs">
                    <tr :key="index" class="row-data">
                      <td>
                        <div class="profile-content center">
                          <input
                            type="checkbox"
                            @change="checkCvs($event, item)"
                          />
                          <img
                            class="cv-thumbnail"
                            src="@/assets/images/temp_docs/new/cv_tumbnail.svg"
                          />
                          <label class="name">{{
                            item.alias | validate
                          }}</label>
                        </div>
                      </td>
                      <td>
                        {{ item.created_at | formatDate }}
                      </td>
                      <td>
                        <button class="btn-download" @click="download(item)">
                          <img
                            src="@/assets/admin-icon/icon-download.svg"
                            alt=""
                          />
                        </button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <div class="empty-widget" v-else>
                <p>No cv uploaded yet or exported</p>
              </div>
            </div>
          </div>
          <div class="my-cvs-options" v-if="selected_download_cv.length > 0">
            <c-button
              @click="downloadConsultantCv()"
              :loading="download_cv_loading"
              class="btn-download-cv"
            >
              Download CV ({{ selected_download_cv.length }})
            </c-button>
          </div>
        </div>
        <div class="consultant-details" :style="{ flexGrow: 1 }" v-else>
          <div class="empty-widget">
            <img src="@/assets/admin-icon/cv-empty-icon.svg" />
            <h1>
              Download, Upload and custom <span>CVs</span> from your
              consultants, efficiently from this section.
            </h1>
            <p>Select one consultant from the left to access more options</p>
          </div>
        </div>
      </multipane>
    </div>

    <!-- Add cv -->
    <div class="cvs-form-widget" v-if="show_form">
      <div class="upload-cv-panel">
        <div class="widget-title">Upload new CV</div>
        <div class="widget-body">
          <div class="input-group">
            <label>CV Name</label>
            <input type="text" v-model="form.cv_name" class="input" />
          </div>
          <div class="input-file-group">
            <label>Attach File</label>
            <div class="file-input-widget">
              <div class="file-input">
                <upload
                  :crop="false"
                  @onFileSelected="
                    (file) => {
                      if (file) {
                        form.cv_file = file;
                      }
                    }
                  "
                  caption="Add File, Supported files are .PDF, .DOC"
                  remove_caption="Remove File"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="widget-option">
          <c-button class="btn-save" :loading="is_loading" @click="submitCV()"
            >Save</c-button
          >
          <button class="cancel" @click="show_form = false">Cancel</button>
        </div>
      </div>
    </div>
    <!-- End -->

    <!-- Export Cv Modal -->
    <exportCvModal
      v-if="showExport"
      :id="selected_consultant.id"
      :names="
        selected_consultant.first_name + ' ' + selected_consultant.last_name
      "
      @onClose="showExport = false"
    ></exportCvModal>
    <!-- End -->
  </div>
</template>

<script>
import { eventBus } from "@/main";
import moment from "moment";
import upload from "@/components/Partials/Uploader.vue";
import exportCvModal from "@/components/Company/exportCvModal.vue";

export default {
  name: "teams",
  components: {
    upload,
    exportCvModal,
  },
  props: {},
  data: () => {
    return {
      show_form: false,
      form: {
        id: null,
        consultant_id: null,
        cv_name: "",
        cv_file: null,
        cv_file_url: "",
      },
      department_data: [],
      department_show_form: false,
      teams_data: [],
      search_input: "",
      selected_consultant: null,
      is_loading: false,
      consultant_cvs: [],
      showExport: false,
      checked_consultant: [],
      selected_download_cv: [],
      cv_download_milt_loading: false,
      download_cv_loading: false,
      cvs_path: [],
    };
  },
  mounted() {
    let vm = this;
    vm.getTeamDepData();
  },
  computed: {
    isPermited() {
      let vm = this;
      return vm.$localStorage.get("main_role") != "team-manager";
    },
  },
  watch: {
    search_input(val) {
      let vm = this;
      vm.searchAll(val);
    },
  },
  methods: {
    exportMiltipleCv() {
      let vm = this;
      vm.cv_download_milt_loading = true;
      vm.$store
        .dispatch("COMPANY_DOWNLOAD_MILT_CVS", { cvs: vm.checked_consultant })
        .then((response) => {
          vm.cv_download_milt_loading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "cvs.zip"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          vm.cv_download_milt_loading = false;
          console.log(error);
          vm.$notify({
            group: "status",
            title: "Something wrong",
            text: "Error while downloading cv, Please try again.",
            type: "warn",
            duration: 3000,
          });
        });
    },
    download(item) {
      let vm = this;
      vm.$store
        .dispatch("COMPANY_DOWNLOAD_CVs_FILE", { name: item.name })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", item.name); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error));
    },
    downloadConsultantCv() {
      let vm = this;
      vm.download_cv_loading = true;
      vm.$store
        .dispatch("COMPANY_DOWNLOAD_MILT_UPLOADED_CVs", {
          cvs: vm.selected_download_cv,
        })
        .then((response) => {
          vm.download_cv_loading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "cvs.zip"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          vm.download_cv_loading = false;
        });
    },
    checkTeam({ target }, team) {
      let vm = this;
      if (target.checked) {
        team.consultants.forEach((item) => {
          item.checked = true;
          let found = vm.checked_consultant.includes(item.id);
          if (!found) {
            vm.checked_consultant.push(item.id);
          }
        });
      } else {
        team.consultants.forEach((item) => {
          item.checked = false;
          const index = vm.checked_consultant.indexOf(item.id);
          if (index > -1) {
            vm.checked_consultant.splice(index, 1);
          }
        });
      }
    },
    checkConsultant({ target }, consultant) {
      let vm = this;
      if (target.checked) {
        consultant.checked = true;
        vm.checked_consultant.push(consultant.id);
      } else {
        consultant.checked = false;
        const index = vm.checked_consultant.indexOf(consultant.id);
        if (index > -1) {
          vm.checked_consultant.splice(index, 1);
        }
      }
    },
    checkCvs({ target }, item) {
      let vm = this;
      if (target.checked) {
        vm.selected_download_cv.push(item.name);
      } else {
        let index = vm.selected_download_cv.indexOf(item.name);
        vm.selected_download_cv.splice(index, 1);
      }
    },
    submitCV() {
      let vm = this;
      let form_data = new FormData();
      form_data.append("cv_name", vm.form.cv_name);
      form_data.append("id", vm.form.id);
      form_data.append("consultant_id", vm.form.consultant_id);
      if (vm.form.cv_file) {
        form_data.append("cv_file", vm.form.cv_file, vm.form.cv_file.name);
      }
      if (!vm.form.id) {
        vm.is_loading = true;
        vm.$store
          .dispatch("COMPANY_UPLOAD_NEW_CV", form_data)
          .then((responce) => {
            vm.is_loading = false;
            vm.show_form = false;
            vm.getConsultantCv(vm.selected_consultant);
            vm.$notify({
              group: "status",
              title: "Message",
              text: "New cv was added",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.is_loading = false;
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Error while adding cv, Please try again.",
              type: "warn",
              duration: 3000,
            });
          });
      } else {
        vm.is_loading = true;
        vm.$store
          .dispatch("COMPANY_UPDATE_UPLOADED_CV", form_data)
          .then((responce) => {
            vm.is_loading = false;
            vm.show_form = false;
            vm.getConsultantCv(vm.selected_consultant);
            vm.$notify({
              group: "status",
              title: "Message",
              text: "New cv was updated",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.is_loading = false;
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Error while updating cv, Please try again.",
              type: "warn",
              duration: 3000,
            });
          });
      }
    },
    addNewCv(selected_consultant) {
      let vm = this;
      vm.form = {
        id: null,
        consultant_id: selected_consultant.id,
        cv_name: "",
        cv_file: null,
        cv_file_url: "",
      };
      vm.show_form = true;
    },
    getConsultantCv(consultant) {
      let vm = this;
      vm.$store
        .dispatch("COMPANY_GET_CONSULTANT_CV", { id: consultant.id })
        .then((responce) => {
          vm.consultant_cvs = responce.data;
        })
        .catch((error) => {});
    },
    viewProfile(item) {
      let vm = this;
      if (item.account_type == 1) {
        let item_id = window.btoa(item.id);
        let name =
          item.first_name.toLowerCase().replace(/\s/g, "-") +
          "-" +
          item.last_name.toLowerCase().replace(/\s/g, "-") +
          "-" +
          item_id;
        window.parent.postMessage(
          {
            message: "routeNow",
            value: {
              name: "consultant-public-profile",
              params: { name: name },
            },
          },
          "*"
        );
      } else if (item.account_type == 2) {
        let item_id = window.btoa(item.id);
        let name =
          item.first_name.toLowerCase().replace(/\s/g, "-") +
          "-" +
          item.last_name.toLowerCase().replace(/\s/g, "-") +
          "-" +
          item_id;

        window.parent.postMessage(
          {
            message: "routeNow",
            value: {
              name: "customer-public-profile",
              params: { name: name },
            },
          },
          "*"
        );
      } else if (item.account_type == 3) {
        let item_id = window.btoa(item.id);
        let name =
          item.first_name.toLowerCase().replace(/\s/g, "-") +
          "-" +
          item.last_name.toLowerCase().replace(/\s/g, "-") +
          "-" +
          item_id;
        window.parent.postMessage(
          {
            message: "routeNow",
            value: {
              name: "supplier-public-profile",
              params: { name: name },
            },
          },
          "*"
        );
      }
    },
    exportCv(consultant) {
      let vm = this;
      vm.showExport = true;
      vm.selected_consultant = consultant;
    },
    expandDepartment(item, i) {
      let vm = this;
      vm.cvs_path = [];
      vm.cvs_path.push({ label: item.name });
      item.expanded = !item.expanded;
    },
    expandTeam(department, team) {
      let vm = this;
      vm.cvs_path = [];
      vm.cvs_path.push({ label: department.name });
      vm.cvs_path.push({ label: team.name, active: true });
      team.expanded = !team.expanded;
    },
    selectConsultant(department, team, consultant) {
      let vm = this;
      vm.cvs_path = [];
      vm.cvs_path.push({ label: department.name });
      vm.cvs_path.push({ label: team.name });
      vm.cvs_path.push({
        label: consultant.first_name + " " + consultant.last_name,
        active: true,
      });
      vm.selected_consultant = consultant;
      vm.getConsultantCv(consultant);
    },
    getTeamDepData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("GET_ALL_USER_INFO")
        .then((response) => {
          vm.$store.dispatch("LOADER_CLOSE");
          if (vm.$localStorage.get("role") == "team-manager") {
            vm.teams_data = response.data;
            vm.teams_data.forEach((team) => {
              team.consultants.forEach((consultant) => {
                eventBus.$set(consultant, "checked", false);
              });
            });
          } else {
            vm.department_data = response.data.map((item, index) => {
              if (vm.active_department == index) {
                eventBus.$set(item, "expanded", true);
              } else {
                eventBus.$set(item, "expanded", false);
              }
              item.teams = item.teams.map((team) => {
                eventBus.$set(team, "expanded", false);
                team.consultants.forEach((consultant) => {
                  eventBus.$set(consultant, "checked", false);
                });
                return team;
              });
              return item;
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.error({ error });
        });
    },
    searchAll(query) {
      let vm = this;
      vm.$store
        .dispatch("ORGANIZATION_SEARCH_DEPARTMENT_TEAM", { quel: query })
        .then((response) => {
          if (vm.$localStorage.get("role") == "team-manager") {
            vm.teams_data = response.data;
          } else {
            vm.department_data = response.data.map((item) => {
              eventBus.$set(item, "expanded", true);
              return item;
            });
          }
        })
        .catch((error) => {
          console.error({ error });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
.teams-wrapper {
  width: 100%;
  height: calc(100% - 0px);
  display: flex;
  flex-direction: column;
  .teams-widget {
    height: 100%;
    position: relative;
    .custom-resizer {
      height: 100%;
    }
    .teams-list {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-width: calc(100% - 550px);
      width: 100%;
      background: #fff;
      border-radius: 5px;
      .teams-header {
        .cvs-path {
          padding: 10px 10px;
          span {
            &.active {
              color: #0884af;
            }

            .divider {
              margin: 0px 4px;
            }
          }
        }
        .search-add-btn-widget {
          padding: 0px 10px;
          display: grid;
          grid-column-gap: 20px;
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
          .search-widget {
            border: 1px solid #ccc;
            height: 45px;
            display: flex;
            align-items: center;
            padding: 0px 10px;
            border-radius: 5px;
            img {
              width: 25px;
              height: 25px;
            }
            input {
              height: 42px;
              width: 100%;
              padding-left: 15px;
              outline: none;
              border: none;
            }
          }
          .add-btn {
            width: 191px;
            height: 45px;
            background: #1885ad 0% 0% no-repeat padding-box;
            border-radius: 5px;
            opacity: 1;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              margin-left: 10px;
            }
          }
        }
        .team-title-options {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #fff;
          padding: 10px 10px;

          .team-title {
            font-size: 20px;
            font-weight: 800;
            margin: 0px;
          }
          .options {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .btn-add {
              background: #0884af;
              border-radius: 5px;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-left: 16px;
              height: 35px;
            }
          }
        }
        .team-tab {
          display: grid;
          grid-template-columns: 50% 50%;
          .tab {
            padding: 21px 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &.active {
              background: #fff;
              border-bottom: 2px solid #1ba5a4;
            }
          }
        }
      }
      .teams-body {
        background: #fff;
        padding: 10px 10px;
        height: calc(87vh - 70px);
        overflow-y: auto;
        .departiment-item {
          margin-bottom: 5px;
          .department-header {
            height: 40px;
            background: #e7e7e7;
            align-items: center;
            display: flex;
            padding: 0px 10px;
            border-radius: 5px;
            justify-content: space-between;
            cursor: pointer;
            &.active {
              background: #d1eded;
              .start {
                width: 99%;
                cursor: pointer;
                .dep-label {
                  color: #1ba5a4;
                  font-size: 14px;
                }
              }
            }
            .start {
              width: 99%;
              cursor: pointer;
              .dep-label {
                color: rgb(95, 95, 95);
                font-size: 14px;
              }
            }
            .options {
              display: flex;
              align-items: center;
              justify-content: space-between;
              button {
                img {
                  width: 15px;
                }
              }
            }
          }
          .department-body {
            padding-left: 15px;
            padding-top: 5px;
            .teams-widget {
              .team-row {
                display: flex;
                flex-direction: column;
                .team-header {
                  height: 50px;
                  display: flex;
                  align-items: center;
                  background: #f2f2f2;
                  border-radius: 5px;
                  margin-bottom: 2px;
                  cursor: pointer;
                  &.active {
                    background: #d1eded;
                  }
                  .checkbox {
                    margin: 0px 20px;
                  }
                  .profile-alphabet {
                    margin-right: 5px;
                    height: 30px !important;
                    width: 30px !important;
                    background: #1ba5a4;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    span {
                      font-size: 10px;
                      color: #fff;
                    }
                  }
                }
                .team-body {
                  padding-left: 20px;
                  .table-data {
                    border-collapse: collapse;
                    border-spacing: 0;
                    margin-bottom: 3px;
                    tr {
                      &.row-data {
                        background: #f9f9f9;
                      }
                      &.hovered {
                        background: #d1eded;
                      }
                      &:hover {
                        background: rgb(248, 248, 248);
                        cursor: pointer;
                      }

                      td {
                        .checkbox {
                          margin: 0px 20px;
                        }
                        p {
                          margin: 0px;
                        }
                        .profile-alphabet {
                          margin-right: 5px;
                          height: 30px !important;
                          width: 30px !important;
                          background: #1ba5a4;
                          span {
                            font-size: 10px;
                            color: #fff;
                          }
                        }

                        .menu {
                          width: 100%;
                          display: flex;
                          justify-content: center;
                          button {
                            padding: 0px;
                            position: relative;
                            left: -3px;
                            img {
                              width: 15px;
                            }
                          }
                        }
                        &:first-child {
                          border-top-left-radius: 5px;
                          border-bottom-left-radius: 5px;
                        }
                        &:last-child {
                          border-top-right-radius: 5px;
                          border-bottom-right-radius: 5px;
                        }
                        text-align: left;
                        border-bottom: none;
                        padding: 8px 3px;
                        font-size: 13px;
                        color: rgb(28, 28, 28);
                        border-bottom: 5px solid #fff;
                        &.center {
                          text-align: center;
                        }
                        .profile-image {
                          height: 30px !important;
                          width: 30px !important;
                          background: #1ba5a438;
                          border-radius: 50%;
                          margin-right: 10px;
                          margin-left: 4px;
                        }
                        .names {
                          margin-left: 0px;
                          .location {
                            color: rgb(170, 170, 170);
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .consultant-details {
      width: 400px;
      min-width: 400px;
      max-width: 550px;
      display: flex;
      padding-right: 5px;
      flex-direction: column;
      height: 100%;
      background: #fff;
      .profile-container {
        .consultant-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #fff;
          padding: 10px 10px;
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
          .consultant-content {
            display: flex;
            align-items: center;
            cursor: pointer;
            .profile-widget {
              .profile-alphabet {
                height: 30px !important;
                width: 30px !important;
                background: #1ba5a438;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #1ba5a4;
                font-size: 10px !important;
                margin-right: 10px;
                margin-left: 4px;
                span {
                  font-size: 10px !important;
                }
              }
              .profile-image {
                height: 30px !important;
                width: 30px !important;
                background: #1ba5a438;
                border-radius: 50%;
                margin-right: 10px;
                margin-left: 4px;
              }
            }
            .consultant-info {
              display: flex;
              flex-direction: column;
              .consultant-name {
                font-size: 15px;
                font-weight: 800;
                margin: 0px;
              }
              .location {
                font-size: 13px;
                color: #ccc;
              }
            }
          }
          .options {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .btn-add {
              background: #0884af;
              border-radius: 5px;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0px 6px;
              height: 35px;
              width: 100px;
              margin-left: 10px;
            }
          }
        }
        .consultant-body {
          padding: 10px 10px;
          h1 {
            margin: 0px;
            font-size: 15px;
          }
          p {
            margin: 0px;
            font-size: 13px;
            text-align: justify;
          }
        }
      }
      .cvs-widget {
        padding: 0px 10px;
        height: 65%;
        display: flex;
        flex-direction: column;
        .my-cvs-header {
          display: flex;
          align-content: center;
          padding: 5px 0px;
          h1 {
            margin: 0px;
          }
        }
        .my-cvs-body {
          overflow-y: auto;
          height: calc(100% - 35px);
          padding: 5px 0px;
          border-top: 1px solid #ddd;
          .table-data {
            border-collapse: collapse;
            border-spacing: 0;
            tr {
              &.row-data {
                background: #efefef;
              }
              cursor: auto;
              th {
                border-bottom: none;
                padding: 10px 3px !important;
                &.center {
                  display: flex;
                  align-content: center;
                  input {
                    position: relative;
                    top: 0px;
                    margin-right: 5px;
                    margin: 0px 20px;
                  }
                }
                &.text-center {
                  text-align: center;
                }
              }
              td {
                .checkbox {
                  margin: 0px 20px;
                }
                .profile-content {
                  .cv-thumbnail {
                    width: 30px;
                    margin-right: 15px;
                  }
                }

                .menu {
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  button {
                    padding: 0px;
                    position: relative;
                    left: -3px;
                    img {
                      width: 15px;
                    }
                  }
                }
                &:first-child {
                  border-top-left-radius: 5px;
                  border-bottom-left-radius: 5px;
                }
                &:last-child {
                  border-top-right-radius: 5px;
                  border-bottom-right-radius: 5px;
                }
                text-align: left;
                border-bottom: none;
                padding: 8px 3px;
                font-size: 13px;
                color: rgb(28, 28, 28);
                border-bottom: 5px solid #fff;
                &.center {
                  text-align: center;
                }
              }
            }
          }
        }
      }
      .my-cvs-options {
        height: 60px;
        display: flex;
        padding: 0px 10px;
        align-items: center;
        border-top: 1px solid #ddd;
        .btn-download-cv {
          background: #0884af;
          border-radius: 5px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0px 6px;
          height: 35px;
          min-width: 100px;
        }
      }
      .empty-widget {
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0px 50px;
        padding-top: 60px;
        img {
          width: 150px;
        }
        h1 {
          font-size: 18px;
          color: rgb(58, 57, 57);
          text-align: center;
          margin-top: 30px;
          span {
            font-size: 18px;
            color: rgb(0, 0, 0);
            font-weight: 800;
          }
        }
        p {
          font-size: 13px;
          color: rgb(58, 57, 57);
          margin-top: 40px;
          text-align: center;
        }
      }
    }
  }

  .cvs-form-widget {
    position: fixed;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    background: rgba(0, 0, 0, 0.8);
    z-index: 99999;
    display: flex;
    justify-content: center;
    padding: 85px;
    overflow-y: auto;
    @media (min-width: 300px) and (max-width: 630px) {
      padding: 85px 10px;
    }
    .upload-cv-panel {
      background: #fff;
      width: 500px;
      min-height: 100px;
      border-radius: 5px;
      display: inline-table;
      padding: 40px;
      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
        padding: 15px;
      }
      .widget-title {
        font-size: 18px;
      }
      .widget-body {
        margin-top: 20px;
        .input-group {
          display: flex;
          flex-direction: column;
          margin-bottom: 10px;
          .input {
            border: 1px solid #ddd;
            height: 45px;
            border-radius: 5px;
            outline: none;
            padding: 0px 15px;
          }
        }
        .input-file-group {
          .file-input-widget {
            height: 150px;
            width: 100%;
            display: flex;
            .file-input {
              width: 100%;
            }
          }
        }
        .replace-input-group {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: 20px;
          label {
            margin-left: 5px;
            margin-top: 4px;
          }
        }
        .cvs-items {
          margin-top: 10px;
          display: grid;
          grid-template-columns: 31.3333% 31.33333% 31.3333%;
          grid-gap: 20px;
          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 48% 48%;
          }
          .cv-item {
            background: #fff;
            border-radius: 5px;
            border: 1px solid #ddd;
            .cv-item-header {
              display: flex;
              justify-content: space-between;
              padding: 0px 5px;
              align-items: center;
              border-bottom: 1px solid #ddd;
              label {
                width: 99%;
                padding-top: 9px;
                font-size: 15px;
                align-items: center;
                display: flex;
                padding-left: 8px;
              }
            }
            .cv-item-body {
              padding: 10px 0px;
              img {
                width: 100%;
              }
            }
          }
        }
      }
      .widget-option {
        margin-top: 30px;
        display: flex;
        align-items: center;
        .btn-cancel {
          color: #1ba5a4;
          cursor: pointer;
          font-weight: normal;
          height: 40px;
          padding: 3px 20px;
          font-size: 14px;
          width: 100px;
        }
        .btn-save {
          background: #1ba5a4;
          color: #fff;
          font-size: 14px;
          font-weight: normal;
          cursor: pointer;
          border-radius: 5px;
          height: 40px;
          width: 100px;
          padding: 3px 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 20px;
          &:disabled {
            background: #8d8d8d;
            opacity: 0.3;
          }
        }
      }
    }
  }
}
</style>
